import ReactGA from 'react-ga4';
import Cookies from 'js-cookie';
import JSSHA from 'jssha';

const HASH_KEY = '4144A3D0-821F-424C-836B-0575B86BD2AF';

const isProd =
  window.location.host === 'www.okcoin.jp' ||
  window.location.host === 'www.okj.com';
const TRACKING_ID_JP = isProd ? 'G-8WC751CTBJ' : 'G-413C7NRCYV';

export function generateHash(text) {
  if (text.length === 0) {
    return '';
  }
  const sha256 = new JSSHA('SHA-256', 'TEXT');
  sha256.update(text + HASH_KEY);
  return sha256.getHash('HEX');
}

export function setLoginNameGA() {
  const loginName = localStorage.getItem('loginName') || '';
  const hash = generateHash(loginName);
  ReactGA.set({ userId: hash });
}

export function setLocaleGA() {
  const locale = Cookies.get('locale');
  ReactGA.set({ dimension1: locale });
}

export function initGA() {
  ReactGA.initialize(TRACKING_ID_JP, {
    debug: !isProd, // If you need to check console log, please set true.
    titleCase: false,
    gaOptions: {
      allowLinker: true,
      linker: {
        domains: ['www.okcoin.jp', 'www.okj.com'], 
        accept_incoming: true,
      }
    },
  });
  setLoginNameGA();
  setLocaleGA();
}
